export type CSVHeaders =
    | 'Client First Name*'
    | 'Client Last Name*'
    | 'Client Preferred Name'
    | 'Client DoB (MM/DD/YYYY)'
    | 'Point of Contact Email*'
    | 'Point of Contact Phone Number ((###) ###-####)'
    | 'Point of Contact First Name*'
    | 'Point of Contact Last Name*'
    | 'Point of Contact Preferred Name';

export type BulkAddClientRecord = {
    clientFirstName: string;
    clientLastName: string;
    clientDOB: string;
    clientPreferredName: string;
    pointOfContactEmail: string;
    pointOfContactFirstName: string;
    pointOfContactLastName: string;
    pointOfContactPreferredName: string;
    pointOfContactPhoneNumber: string;
};

export const csvHeaders: CSVHeaders[] = [
    'Client First Name*',
    'Client Last Name*',
    'Client Preferred Name',
    'Client DoB (MM/DD/YYYY)',
    'Point of Contact Email*',
    'Point of Contact Phone Number ((###) ###-####)',
    'Point of Contact First Name*',
    'Point of Contact Last Name*',
    'Point of Contact Preferred Name',
];

export const csvHeadersMap: Record<CSVHeaders, keyof BulkAddClientRecord> = {
    'Client First Name*': 'clientFirstName',
    'Client Last Name*': 'clientLastName',
    'Client Preferred Name': 'clientPreferredName',
    'Client DoB (MM/DD/YYYY)': 'clientDOB',
    'Point of Contact Email*': 'pointOfContactEmail',
    'Point of Contact Phone Number ((###) ###-####)': 'pointOfContactPhoneNumber',
    'Point of Contact First Name*': 'pointOfContactFirstName',
    'Point of Contact Last Name*': 'pointOfContactLastName',
    'Point of Contact Preferred Name': 'pointOfContactPreferredName',
};

export const propFromHeader = (header: CSVHeaders): keyof BulkAddClientRecord => csvHeadersMap[header];
export const headerFromProp = (prop: keyof BulkAddClientRecord): CSVHeaders =>
    Object.keys(csvHeadersMap).find((key) => csvHeadersMap[key as CSVHeaders] === prop) as CSVHeaders;
